/**
 * The message to show an operator for a failed backend request.
 *
 * FastAPI sends a refusal's reason in `detail`: a sentence for an HTTPException
 * (the 422 of a ceiling, say), or an array of {type, loc, msg, input} for a
 * validation error. The array has to be unpacked, because handing it to
 * toast.error or rendering it as a JSX child crashes React with "Objects are
 * not valid as a React child".
 *
 * @param {unknown} err the error axios threw
 * @param {string} fallback shown when the response carries no detail
 * @returns {string}
 */
export const apiErrorMessage = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join("; ");
  return detail || fallback;
};
